import React from 'react';
import { cn } from '../../lib/utils';

/** Brand ink panel: one finding + one action. */
export function InsightPanel({
  eyebrow = 'Focus',
  title,
  action,
  className,
}) {
  if (!title) return null;

  return (
    <aside
      className={cn(
        'rounded-xl bg-[var(--brand-primary,#1A428A)] px-4 py-4 text-white shadow-sm',
        className
      )}
    >
      <p className="font-display text-[10px] font-bold uppercase tracking-[0.14em] text-white/70">
        {eyebrow}
      </p>
      <p className="mt-2 text-sm font-semibold leading-snug">{title}</p>
      {action ? (
        <div className="mt-3 border-t border-white/20 pt-3">
          <p className="font-display text-[10px] font-bold uppercase tracking-[0.12em] text-white/65">
            Do next
          </p>
          <p className="mt-1 text-xs leading-relaxed text-white/95">{action}</p>
        </div>
      ) : null}
    </aside>
  );
}
